import { useEffect, useRef, useState } from "react";
import {
  Group,
  Text,
  UnstyledButton,
  TextInput,
  Box,
  ActionIcon,
  ThemeIcon,
  useMantineTheme,
  Code,
  Indicator,
  Skeleton,
  Loader,
  CloseButton,
  Tooltip,
  Stack,
} from "@mantine/core";
import {
  IconArrowUpRight,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import { closeAllModals } from "@mantine/modals";
import { useForm } from "@mantine/form";
import { logger } from "utils/logger";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  fetchGlobalSearch,
  getStyleSuccess,
  setFilter,
  setPreviousRoute,
  getGlobalSearchSuccess,
  setGlobalSearch,
} from "app/appSlice";
import ResolverImage from "../resolverImage/ResolverImage";
import { EmptyState } from "../emptyState/EmptyState";
import StylePopover from "../popovers/StylePopover";
import Moment from "react-moment";
import { createStyles } from "@mantine/emotion";
import MastersList from "./MastersList";

import MasterDrawer from "./MasterDrawer";
import { getCompanyTableColumns } from "utils/constants";
// import type { SpotlightAction } from '@mantine/spotlight';

const useStyles = createStyles((theme, _, u) => ({
  spotlightItem: {
    width: "100%",
    "&:hover": {
      background: theme.colorScheme === "dark",
      [u.light]: {
        background: theme.colors.gray[1],
      },
    },
    borderRadius: theme.radius.sm,
  },
  inputWrapper: {
    width: "100%",
    // height: '34px',
    // borderRadiusTop: `${theme.radius.md}px`,
    color: theme.colors.dark[1],
    backgroundColor: theme.colors.dark[6],
    // borderBottom: `1px solid ${theme.colors.dark[6]}`,
    // borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[4],
    padding: `0px ${theme.spacing.sm / 2}px`,
    paddingLeft: theme.spacing.md,
    [u.light]: {
      backgroundColor: theme.white,
      color: theme.colors.gray[6],
      // borderBottom: `1px solid ${theme.colors.gray[4]}`,
    },
  },
  input: {
    input: {
      border: 0,
      background: "transparent",
      width: "100%",
      border: 0,
    },
    background: "transparent",
    flex: 1,
    flexGrow: `1 !important`,
  },
  container: {
    background: theme.colors.dark[6],
    overflow: "hidden",
    height: "100vh",
    [u.light]: {
      background: theme.white,
    },
  },
  code: {
    // subscribe to color scheme changes
    border: `1px solid ${theme.colors.dark[3]}`,
    marginRight: theme.spacing.sm,
    [u.light]: {
      border: `1px solid ${theme.colors.gray[2]}`,
    },
  },

  resultHolder: {
    transition: "all .2s ease-in-out",
    maxHeight: 50,
    overflow: "hidden",
    "&.open": {
      maxHeight: "90vh",
    },
    // borderBottom: `1px solid ${theme.colors.dark[3]}`,
    // [u.light]: {
    //   borderBottom: `1px solid ${theme.colors.gray[2]}`,
    // },
  },
  drawer: {
    maxWidth: 0,
    transition: "all .2s ease-in-out",
    overflow: "hidden",
    // maxHeight: 0,
    opacity: 0,
    // borderLeft: `1px solid ${theme.colors.dark[6]}`,

    [u.light]: {
      // borderLeft: `1px solid ${theme.colors.gray[4]}`,
    },
    "&.open": {
      minWidth: 400,
      maxWidth: 400,
      maxHeight: "100%",
      opacity: 1,
    },
  },
}));

const SpotlightForm = ({
  style,
  filter,
  success,
  error,
  user,
  globalSearch,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  // const [data, setData] = useState();
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const keywordRef = useRef();

  useEffect(() => {
    if (success && success.type === getStyleSuccess.toString()) {
      setIsLoading(false);
    }

    if (success && success.type === getGlobalSearchSuccess.toString()) {
      setIsLoading(false);
    }

    if (error) {
      setIsLoading(false);
    }
    // setIsLoading(true);
  }, [success, error]);

  useEffect(() => {
    setTimeout(() => {
      keywordRef.current?.select();
    }, 200);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // If asset viewer is open, close it first
        if (globalSearch?.imageModalOpen) {
          dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: false }));
        } else {
          // Otherwise, close the main modal
          closeAllModals();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [globalSearch, dispatch]);

  const form = useForm({
    initialValues: {
      keyword: filter.keyword,
    },

    validate: {
      keyword: (value) => (value.length ? null : "Enter style"),
    },
  });

  const onFormSubmit = async (values) => {
    // fetch the timeline.
    logger.log(values);

    setIsLoading(true);

    dispatch(
      setFilter({ keyword: values.keyword, pageIndex: 0, pageSize: 50 })
    );

    // const timeline = await getStyleTimeline({ id: values.keyword });
    // dispatch(fetchStyleTimeline({ keyword: values.keyword }));
    dispatch(fetchGlobalSearch({ keyword: values.keyword }, user));
    // setData(timeline.Timeline);
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const drawerOpen = globalSearch?.drawerOpen ?? false;

  useEffect(() => {
    if (globalSearch?.results && globalSearch.results.length === 0) {
      setSelectedItem(null);
      if (drawerOpen) {
        dispatch(setGlobalSearch({ ...globalSearch, drawerOpen: false }));
      }
    }
  }, [globalSearch?.results, drawerOpen, dispatch, globalSearch]);

  const onItemClick = (route) => {
    // navigate(route);
    // closeAllModals();
    logger.log(route.original, filter);

    setSelectedItem({ ...route.original });
    const {styleNumber, ...rest} = route.original;
    const tmpGlobalSearch = { ...globalSearch, drawerOpen: true };
    dispatch(setGlobalSearch(tmpGlobalSearch  ));
  };

  // const styleItem = style && style.styles && style.styles.length ? [style.styles[0]] : null;
  // const styleItem =
  //   style && style.baseStyle && style.baseStyle.length
  //     ? [style.baseStyle[0]]
  //     : null;

  const styleItem =
    style && style.masters && style.masters.length ? [style.masters[0]] : null;

  const loaderRows = [1, 2].map((val, key) => (
    <Box key={key} className="" pt={"md"}>
      <ItemRenderer />
    </Box>
  ));

  logger.log(style, globalSearch);
  const columns = user?.clientCode?getCompanyTableColumns(user.clientCode, "masters"):[];

  const [panelHeight, setPanelHeight] = useState("100%");
  const modalContentRef = useRef(null);

  // Calculate panel height using ResizeObserver for efficiency
  useEffect(() => {
    const updateHeight = (height) => {
      if (height > 0) {
        setPanelHeight(height - 100);
      }
    };

    // Find and observe modal content element
    const findAndObserve = () => {
      const modalContent = document.querySelector(
        ".spotlightModal .mantine-Modal-content"
      );

      if (!modalContent) return;

      modalContentRef.current = modalContent;

      // Initial calculation
      updateHeight(modalContent.clientHeight);

      // ResizeObserver handles all subsequent changes efficiently
      const resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (entry) {
          updateHeight(entry.target.clientHeight);
        }
      });

      resizeObserver.observe(modalContent);

      return () => {
        resizeObserver.disconnect();
        modalContentRef.current = null;
      };
    };

    // Wait for next frame to ensure modal is rendered
    const rafId = requestAnimationFrame(findAndObserve);

    return () => {
      cancelAnimationFrame(rafId);
    };
  }, [globalSearch?.results, drawerOpen]);

  return (
    <div className={classes.container}>
      <Group
        className={
          // style ? [classes.resultHolder, "open"] : [classes.resultHolder]
          globalSearch?.results && globalSearch?.results.length
            ? [classes.resultHolder, "open"]
            : [classes.resultHolder]
        }
        style={{ height: "100%", width: "100%" }}
        wrap="nowrap"
        align="flex-start"
        justify="flex-start"
        gap="xs"
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            paddingBottom: 50,
            maxWidth: drawerOpen ? `calc(100% - 420px)` : `100%`,
            transition: "all .2s ease-in-out",
          }}
        >
          <form onSubmit={form.onSubmit((values) => onFormSubmit(values))}>
            <Group
              wrap="nowrap"
              className={classes.inputWrapper}
              gap={0}
              pl={0}
              // pr={"md"}
            >
              {/* <IconSearch size={20} c="grey" /> */}
              <TextInput
                leftSection={<IconSearch size={20} c="grey" />}
                p={0}
                className={classes.input}
                size="lg"
                placeholder="Enter Keyword or Style Number"
                data-autofocus
                ref={keywordRef}
                {...form.getInputProps("keyword")}
              />
              {form.isValid() ? (
                <ActionIcon
                  variant="transparent"
                  mr={"xs"}
                  onClick={(e) => {
                    form.setFieldValue("keyword", "");
                    keywordRef.current?.focus();
                    dispatch(
                      setFilter({ keyword: "", pageIndex: 0, pageSize: 50 })
                    );
                  }}
                >
                  <IconX color="white" stroke={1} />
                </ActionIcon>
              ) : null}
              {isLoading ? (
                <Loader size={"sm"} type="dots" mr={"lg"} />
              ) : (
                <Code className={classes.code}>↵ Enter</Code>
              )}

              {/* {form.isValid() ? (
            <ActionIcon
              variant="transparent"
              mr={"xs"}
              onClick={(e) => {
                form.setFieldValue("keyword", "");
                keywordRef.current?.focus();
                dispatch(
                  setFilter({ keyword: "", pageIndex: 0, pageSize: 50 })
                );
              }}
            >
              <IconX color="white" />
            </ActionIcon>
          ) : null} */}

              {/* <CloseButton onClick={() => closeAllModals()} /> */}
              {globalSearch?.results && globalSearch?.results.length ? (
                <Tooltip
                  position="bottom"
                  label={drawerOpen ? "Hide Info Panel" : "Show Info Panel"}
                >
                  <ActionIcon
                    mr={"sm"}
                    variant="default"
                    onClick={() =>
                      dispatch(
                        setGlobalSearch({
                          ...globalSearch,
                          drawerOpen: !drawerOpen,
                        })
                      )
                    }
                    size={"lg"}
                  >
                    {drawerOpen ? (
                      <IconLayoutSidebarRightCollapse size={18} />
                    ) : (
                      <IconLayoutSidebarRightExpand size={18} />
                    )}
                  </ActionIcon>
                </Tooltip>
              ) : null}
            </Group>
          </form>
          <Box>
            <Box p={0} pt={0}>
              {/* <Table highlightOnHover> */}
              <Box px={"sm"} pb={0}>
                {isLoading ? <ItemRenderer /> : null}

                {!isLoading &&
                globalSearch?.results &&
                globalSearch?.results.length ? (
                  <Group wrap="nowrap" justify="flex-start" align="flex-start">
                    <div
                      style={{
                        height: "100%",
                        // paddingBottom: 33,
                        maxWidth: `calc(100% - 0px)`,
                      }}
                    >
                      <div
                        className="table-wrapper"
                        style={{
                          position: "relative",
                          height: panelHeight,
                        }}
                      >
                        <MastersList
                          columns={columns ?? []}
                          originalData={globalSearch?.results || []}
                          loading={isLoading}
                          data={globalSearch?.results || []}
                          onItemClick={(item) => onItemClick(item)}
                          selectedItems={
                            // globalSearch?.style ? [globalSearch?.style] : []
                            // we need to use the selected item if it is available otherwise use the global search style
                            selectedItem ? [selectedItem] : []
                          }
                          leftColumnPinning={["TARGET KEYCODE"]}
                          filter={filter}
                          setFilter={(filter) => {
                            dispatch(setFilter(filter));
                          }}
                          // onMenuItemClick={onMenuItemClick}
                          // onItemSelected={onItemSelected}
                          // selectedItems={selectedStyles}
                          // filter={wipFilter}
                          // actionMenu={rowMenuItems}
                          // columns={columns}
                          // setFilter={setWipFilter}
                        />
                      </div>
                    </div>
                  </Group>
                ) : null}

                {!isLoading && style && style.styles && style.styles.length ? (
                  <div>
                    {" "}
                    {styleItem.map((val, idx) => {
                      return (
                        <StylePopover
                          key={idx}
                          data={{
                            ...val,
                            preview:
                              style.styles && style.styles.length
                                ? style.styles[0].preview
                                : "",
                            stylePart: val.styleNumber,
                            styleSort: val.styleNumber,
                            assets: style.styles.map((val) => ({ ...val })),
                          }}
                          onShowDetails={closeAllModals}
                        >
                          <UnstyledButton
                            onClick={() =>
                              onItemClick(`/distributions/${val.styleNumber}`)
                            }
                            className={classes.spotlightItem}
                            px={"sm"}
                            py={"md"}
                            key={idx}
                          >
                            <Group justify="space-between" wrap="nowrap">
                              <Group spacing="sm" align="start" wrap="nowrap">
                                <div style={{ position: "relative" }}>
                                  <Indicator
                                    inline
                                    label={style.styles.length}
                                    style={{
                                      ".mantine-MachineNumber-currentNumber": {
                                        lineHeight: `16px !important`,
                                      },
                                    }}
                                    size={16}
                                  >
                                    <div style={{ position: "relative" }}>
                                      <ResolverImage
                                        width={30}
                                        height={30}
                                        src={
                                          style.styles && style.styles.length
                                            ? style.styles[0].thumb
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Indicator>
                                </div>

                                <div>
                                  <Text size="sm" weight={500}>
                                    {val.styleNumber}
                                  </Text>
                                  <Group>
                                    <Text
                                      size="xs"
                                      c="dimmed"
                                      truncate
                                      style={{ maxWidth: 300 }}
                                    >
                                      {val.name}
                                    </Text>
                                  </Group>
                                  {val.distributionDate &&
                                  val.distributionDate.length ? (
                                    <Group>
                                      <Text size="xs" c="dimmed">
                                        Distributed →{" "}
                                        <Moment
                                          date={val.distributionDate}
                                          parse="YYYY-MM-DD-hh-mm-ss"
                                          format="DD/MM/YYYY"
                                          trim
                                        />{" "}
                                      </Text>
                                    </Group>
                                  ) : null}

                                  {/* <Group>
                                                            <Badge c={getStyleStatusColor(val.status)}>{val.status}</Badge>
                                                                <Text size='sm'>
                                                                    <Moment date={val.distributionDate} parse='YYYY-MM-DD-hh-mm-ss' format='DD/MM/YYYY' trim />
                                                                </Text>
                                                            </Group> */}
                                </div>
                              </Group>
                              <Group wrap="nowrap">
                                {/* <Badge c={getStyleStatusColor(val.status)}>
                              {val.status}
                            </Badge> */}
                                <ThemeIcon variant="light">
                                  <IconArrowUpRight size={18} />
                                </ThemeIcon>
                              </Group>
                            </Group>
                          </UnstyledButton>
                        </StylePopover>
                      );
                    })}{" "}
                  </div>
                ) : null}
                {/* </Table> */}
                {!isLoading &&
                style &&
                style.styles &&
                style.styles.length === 0 ? (
                  <EmptyState
                    style={{ paddingTop: 10, paddingBottom: 10 }}
                    showImage={false}
                    caption="No style found"
                  />
                ) : null}
              </Box>
            </Box>
          </Box>
        </div>
        <div
          className={[classes.drawer, drawerOpen && "open"]
            .filter(Boolean)
            .join(" ")}
          style={{ minHeight: "100%", height: panelHeight }}
        >
          <Group px={0} py="sm" pb="sm" align="center" justify="space-between">
            <Text size="md">Style Details</Text>
            <CloseButton
              title="Close Info Panel"
              onClick={() =>
                dispatch(
                  setGlobalSearch({ ...globalSearch, drawerOpen: false })
                )
              }
            />
          </Group>

          <MasterDrawer
            open={drawerOpen}
            onClose={() =>
              dispatch(setGlobalSearch({ ...globalSearch, drawerOpen: false }))
            }
            item={selectedItem}
            globalSearch={globalSearch}
            user={user}
          />
        </div>
      </Group>

      {globalSearch?.results && globalSearch?.results.length === 0 ? (
        <Box
          className="empty-state-container"
          style={{ borderTop: `1px solid ${theme.colors.dark[8]}` }}
        >
          <EmptyState
            style={{ paddingTop: 10, paddingBottom: 10 }}
            showImage={false}
            caption="No results found"
          />
        </Box>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isLoading: state.appReducer.loading,
  globalSearch: state.appReducer.globalSearch,
  style: state.appReducer.style,
  filter: state.appReducer.filter,
  success: state.appReducer.success,
  error: state.appReducer.error,
});

const mapDispatchToProps = { setPreviousRoute };

export default connect(mapStateToProps, mapDispatchToProps)(SpotlightForm);

const ItemRenderer = () => {
  return (
    <Stack py={3} px={"sm"}>
      <Group position="apart">
        <Group style={{ width: "100%" }} gap={"xs"}>
          <Skeleton height={16} radius="sm" width={"10%"} pr={"sm"} />
          <Skeleton height={16} radius="xl" width={"10%"} />
          <Skeleton height={16} radius="sm" width={"72%"} />
          {/* <Skeleton height={10} radius="xl" width={100} /> */}
        </Group>
      </Group>

      <Group position="apart">
        <Group style={{ width: "100%" }} gap={"xs"}>
          <Skeleton height={16} radius="sm" width={"10%"} pr={"sm"} />
          <Skeleton height={16} radius="xl" width={"10%"} />
          <Skeleton height={16} radius="sm" width={"72%"} />
          {/* <Skeleton height={10} radius="xl" width={100} /> */}
        </Group>
      </Group>
    </Stack>
  );
};
